import { render } from "./DetailsAuth.vue?vue&type=template&id=b4c4e2f6"
import script from "./DetailsAuth.vue?vue&type=script&lang=js"
export * from "./DetailsAuth.vue?vue&type=script&lang=js"

import "./DetailsAuth.vue?vue&type=style&index=0&id=b4c4e2f6&lang=css"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__